export default {
  'errors.page-not-found/title': 'Oops...',
  'errors.page-not-found/description':
    'Parece que la página que estás buscando no existe',
  'errors.page-not-found/go-to-home': 'Volver al inicio',
};
